import React, { Component } from 'react';

import JSONLDUtils from 'common/util/JsonLdUtils';

import Helmet from './Helmet';

const Title = 'Sales Documentation | Canny';
const Description =
  'Close more deals by informing your product team on what prospects are asking for.';
const Image = 'https://canny.io/images/canny-social.png';
const SalesDocumentationUrl = 'https://canny.io/use-cases/sales-documentation';

const jsonLdGraph = JSONLDUtils.createGraph([
  JSONLDUtils.createWebPage({
    '@id': `${SalesDocumentationUrl}#webpage`,
    url: SalesDocumentationUrl,
    name: 'Sales Documentation - Canny',
    description:
      'Use Canny to streamline sales documentation by centralizing requests, tracking internal input, and ensuring the right resources are available for your sales team.',
    inLanguage: 'en',
    about: { '@id': 'https://canny.io/#app' },
    isPartOf: { '@id': 'https://canny.io/#website' },
  }),
  JSONLDUtils.createWebApplicationItemList(
    `${SalesDocumentationUrl}#capabilities`,
    'Sales Documentation Capabilities',
    [
      {
        name: 'Collect Sales Team Requests',
        description:
          'Centralize requests from sales teams to ensure needed resources are captured and tracked.',
      },
      {
        name: 'Manage and Prioritize Documentation Needs',
        description:
          'Organize and rank internal documentation requests to ensure high-impact updates are delivered first.',
      },
      {
        name: 'Keep Sales Collateral Up to Date',
        description:
          'Maintain a single source of truth for sales enablement materials, ensuring the latest information is always accessible.',
      },
      {
        name: 'Improve Sales–Product Alignment',
        description:
          'Link documentation updates to product changes and feedback to align sales messaging with current capabilities.',
      },
    ],
  ),
  JSONLDUtils.createBreadcrumbList([
    { name: 'Home', item: 'https://canny.io/' },
    { name: 'Use Cases', item: 'https://canny.io/use-cases' },
    { name: 'Sales Documentation', item: SalesDocumentationUrl },
  ]),
]);

export default class LandingSalesHelmet extends Component {
  render() {
    return (
      <Helmet
        title={Title}
        meta={[
          { name: 'description', content: Description },

          { property: 'og:image', content: Image },
          { property: 'og:title', content: Title },
          { property: 'og:description', content: Description },
          { property: 'og:url', content: SalesDocumentationUrl },
          { property: 'og:type', content: 'website' },

          { name: 'twitter:card', content: 'summary_large_image' },
          { name: 'twitter:site', content: '@cannyHQ' },
          { name: 'twitter:title', content: Title },
          { name: 'twitter:description', content: Description },
          { name: 'twitter:image', content: Image },
        ]}>
        <script type="application/ld+json">{JSONLDUtils.toString(jsonLdGraph)}</script>
      </Helmet>
    );
  }
}
